import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Custom hook to check if a user has completed onboarding
 * If not, redirects to the onboarding page
 */
export function useOnboardingCheck() {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && user?.onboardingStatus === 'pending') {
      navigate('/onboarding', { replace: true });
    }
  }, [isLoading, user, navigate]);

  return {
    isOnboardingComplete: !isLoading && user?.onboardingStatus === 'completed',
  };
} 